import api from './index';

export default {
    login: (data) => api.raw.post('login/', data, { isAuth: false }),
    logout: () => api.raw.post('login/logout/', {}, { isAuth: true }),
    refresh: (data) => api.raw.post('login/refresh/', data, { isAuth: true }),
}